import { render } from "./TopNavigation.vue?vue&type=template&id=3589bbac&scoped=true&ts=true"
import script from "./TopNavigation.vue?vue&type=script&lang=ts"
export * from "./TopNavigation.vue?vue&type=script&lang=ts"

import "./TopNavigation.vue?vue&type=style&index=0&id=3589bbac&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3589bbac"]])

export default __exports__